import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  TimeBasedDateTimeUnitSerializer_getInstance1xwms177r5lzr as TimeBasedDateTimeUnitSerializer_getInstance,
  DateBasedDateTimeUnitSerializer_getInstance1akx7bb1vxf8c as DateBasedDateTimeUnitSerializer_getInstance,
  DayBasedDateTimeUnitSerializer_getInstance1xxpx4q7emkpv as DayBasedDateTimeUnitSerializer_getInstance,
  MonthBasedDateTimeUnitSerializer_getInstance3dqgiv5zfsawe as MonthBasedDateTimeUnitSerializer_getInstance,
  DateTimeUnitSerializer_getInstance4ttb7w16orlx as DateTimeUnitSerializer_getInstance,
} from './serializers/DateTimeUnitSerializers.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  modulooi4g1kq3dmtt as modulo,
  dividelr0uqtdj497z as divide,
  convertToInty04h231mmjoh as convertToInt,
  shiftRight2gqph14wydb8s as shiftRight,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  safeMultiply1xb0xo3cufzd3 as safeMultiply,
  safeMultiplyomi65rg5l1en as safeMultiply_0,
} from './internal/mathNative.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var TimeBasedClass;
function TimeBased() {
  if (TimeBasedClass === VOID) {
    class $ extends DateTimeUnit() {
      constructor(nanoseconds) {
        super();
        this.nanoseconds_1 = nanoseconds;
        // Inline function 'kotlin.require' call
        if (!(this.nanoseconds_1 > 0n)) {
          var message = 'Unit duration must be positive, but was ' + this.nanoseconds_1.toString() + ' ns.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        if (modulo(this.nanoseconds_1, 3600000000000n) === 0n) {
          this.unitName_1 = 'HOUR';
          this.unitScale_1 = divide(this.nanoseconds_1, 3600000000000n);
        } else {
          if (modulo(this.nanoseconds_1, 60000000000n) === 0n) {
            this.unitName_1 = 'MINUTE';
            this.unitScale_1 = divide(this.nanoseconds_1, 60000000000n);
          } else {
            var tmp0 = this.nanoseconds_1;
            // Inline function 'kotlin.Long.rem' call
            var other = 1000000000;
            if (modulo(tmp0, fromInt(other)) === 0n) {
              this.unitName_1 = 'SECOND';
              var tmp = this;
              var tmp0_0 = this.nanoseconds_1;
              // Inline function 'kotlin.Long.div' call
              var other_0 = 1000000000;
              tmp.unitScale_1 = divide(tmp0_0, fromInt(other_0));
            } else {
              // Inline function 'kotlin.Long.rem' call
              var this_0 = this.nanoseconds_1;
              if (modulo(this_0, fromInt(1000000)) === 0n) {
                this.unitName_1 = 'MILLISECOND';
                var tmp_0 = this;
                // Inline function 'kotlin.Long.div' call
                var this_1 = this.nanoseconds_1;
                tmp_0.unitScale_1 = divide(this_1, fromInt(1000000));
              } else {
                // Inline function 'kotlin.Long.rem' call
                var this_2 = this.nanoseconds_1;
                if (modulo(this_2, fromInt(1000)) === 0n) {
                  this.unitName_1 = 'MICROSECOND';
                  var tmp_1 = this;
                  // Inline function 'kotlin.Long.div' call
                  var this_3 = this.nanoseconds_1;
                  tmp_1.unitScale_1 = divide(this_3, fromInt(1000));
                } else {
                  this.unitName_1 = 'NANOSECOND';
                  this.unitScale_1 = this.nanoseconds_1;
                }
              }
            }
          }
        }
      }
      times_kr2a3y_k$(scalar) {
        return new (TimeBased())(safeMultiply(this.nanoseconds_1, fromInt(scalar)));
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof TimeBased()) {
            tmp_0 = this.nanoseconds_1 === other.nanoseconds_1;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return convertToInt(this.nanoseconds_1) ^ convertToInt(shiftRight(this.nanoseconds_1, 32));
      }
      toString() {
        return this.formatToString_d2c8zd_k$(this.unitScale_1, this.unitName_1);
      }
    }
    initMetadataForClass($, 'TimeBased', VOID, VOID, VOID, VOID, VOID, {0: TimeBasedDateTimeUnitSerializer_getInstance});
    TimeBasedClass = $;
  }
  return TimeBasedClass;
}
var DateBasedClass;
function DateBased() {
  if (DateBasedClass === VOID) {
    class $ extends DateTimeUnit() {}
    initMetadataForClass($, 'DateBased', VOID, VOID, VOID, VOID, VOID, {0: DateBasedDateTimeUnitSerializer_getInstance});
    DateBasedClass = $;
  }
  return DateBasedClass;
}
var DayBasedClass;
function DayBased() {
  if (DayBasedClass === VOID) {
    class $ extends DateBased() {
      constructor(days) {
        super();
        this.days_1 = days;
        // Inline function 'kotlin.require' call
        if (!(this.days_1 > 0)) {
          var message = 'Unit duration must be positive, but was ' + this.days_1 + ' days.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      times_kr2a3y_k$(scalar) {
        return new (DayBased())(safeMultiply_0(this.days_1, scalar));
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof DayBased()) {
            tmp_0 = this.days_1 === other.days_1;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.days_1 ^ 65536;
      }
      toString() {
        return (this.days_1 % 7 | 0) === 0 ? this.formatToString_rm4xej_k$(this.days_1 / 7 | 0, 'WEEK') : this.formatToString_rm4xej_k$(this.days_1, 'DAY');
      }
    }
    initMetadataForClass($, 'DayBased', VOID, VOID, VOID, VOID, VOID, {0: DayBasedDateTimeUnitSerializer_getInstance});
    DayBasedClass = $;
  }
  return DayBasedClass;
}
var MonthBasedClass;
function MonthBased() {
  if (MonthBasedClass === VOID) {
    class $ extends DateBased() {
      constructor(months) {
        super();
        this.months_1 = months;
        // Inline function 'kotlin.require' call
        if (!(this.months_1 > 0)) {
          var message = 'Unit duration must be positive, but was ' + this.months_1 + ' months.';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      times_kr2a3y_k$(scalar) {
        return new (MonthBased())(safeMultiply_0(this.months_1, scalar));
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof MonthBased()) {
            tmp_0 = this.months_1 === other.months_1;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.months_1 ^ 131072;
      }
      toString() {
        return (this.months_1 % 1200 | 0) === 0 ? this.formatToString_rm4xej_k$(this.months_1 / 1200 | 0, 'CENTURY') : (this.months_1 % 12 | 0) === 0 ? this.formatToString_rm4xej_k$(this.months_1 / 12 | 0, 'YEAR') : (this.months_1 % 3 | 0) === 0 ? this.formatToString_rm4xej_k$(this.months_1 / 3 | 0, 'QUARTER') : this.formatToString_rm4xej_k$(this.months_1, 'MONTH');
      }
    }
    initMetadataForClass($, 'MonthBased', VOID, VOID, VOID, VOID, VOID, {0: MonthBasedDateTimeUnitSerializer_getInstance});
    MonthBasedClass = $;
  }
  return MonthBasedClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        this.NANOSECOND_1 = new (TimeBased())(1n);
        this.MICROSECOND_1 = this.NANOSECOND_1.times_kr2a3y_k$(1000);
        this.MILLISECOND_1 = this.MICROSECOND_1.times_kr2a3y_k$(1000);
        this.SECOND_1 = this.MILLISECOND_1.times_kr2a3y_k$(1000);
        this.MINUTE_1 = this.SECOND_1.times_kr2a3y_k$(60);
        this.HOUR_1 = this.MINUTE_1.times_kr2a3y_k$(60);
        this.DAY_1 = new (DayBased())(1);
        this.WEEK_1 = this.DAY_1.times_kr2a3y_k$(7);
        this.MONTH_1 = new (MonthBased())(1);
        this.QUARTER_1 = this.MONTH_1.times_kr2a3y_k$(3);
        this.YEAR_1 = this.MONTH_1.times_kr2a3y_k$(12);
        this.CENTURY_1 = this.YEAR_1.times_kr2a3y_k$(100);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var DateTimeUnitClass;
function DateTimeUnit() {
  if (DateTimeUnitClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance_3();
      }
      formatToString_rm4xej_k$(value, unit) {
        return value === 1 ? unit : '' + value + '-' + unit;
      }
      formatToString_d2c8zd_k$(value, unit) {
        return value === 1n ? unit : value.toString() + '-' + unit;
      }
    }
    initMetadataForClass($, 'DateTimeUnit', VOID, VOID, VOID, VOID, VOID, {0: DateTimeUnitSerializer_getInstance});
    DateTimeUnitClass = $;
  }
  return DateTimeUnitClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
//endregion
//region block: exports
export {
  Companion_getInstance_3 as Companion_getInstance3rf6ssn2f6rf5,
  DateBased as DateBasedu1hioe8kvjhw,
  DayBased as DayBased28hvf1xjg5r93,
  MonthBased as MonthBased16lxw4e6nhntg,
  TimeBased as TimeBasedn2y4mla0fo0k,
  DateTimeUnit as DateTimeUnit3ugctnw90699o,
};
//endregion

//# sourceMappingURL=DateTimeUnit.mjs.map
